// extracted by mini-css-extract-plugin
module.exports = {"button":"copy-icon-button__button___3XEBX"};